import { FC } from 'react';
import { Select } from '@dynamika-shared/ui/Select/Select';
import { AuthUser, UserRoles } from '@dynamika-shared/types/auth';

type ProfilePageViewProps = {
  user: AuthUser;
  handleUserRole: (role: UserRoles) => void;
};

export const ProfilePageView: FC<ProfilePageViewProps> = ({
  user,
  handleUserRole,
}) => {
  return (
    <div data-testid='ProfileView'>
      <h1>Profile</h1>
      <div>"name": {user.nickname}</div>
      <div>"email": {user.email}</div>
      <Select
        label='User role'
        value={{
          label: user.selectedRole,
          value: user.selectedRole,
        }}
        options={user?.['dynamika7/user_metadata']?.roles?.map(role => ({
          label: role,
          value: role,
        }))}
        onSelect={(selected: UserRoles) => {
          handleUserRole(selected);
        }}
      />
    </div>
  );
};
